<template>
  <div class="prbg-white prrounded prborder p-3 ">
    <div class="col-12 col-md-12 " style="width: 100%;">
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs" role="tablist" style="flex-wrap:nowrap !important">
          <li class="nav-item w-50">
            <a class="nav-link w-100" @click="flagFlag('one')" style="width: max-content;" role="tab" aria-controls="first" aria-selected="true">درآمدها</a>
          </li>
          <li class="nav-item w-50">
            <a class="nav-link w-100" @click="flagFlag('two')" style="width: max-content;" role="tab" aria-controls="two" aria-selected="true">دوستان من</a>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div class="tab-pane fade " :class="{ 'active show': flag.one }" id="first" role="tabpanel" aria-labelledby="first-tab">
            <div class="alert alert-warning my-1 border-0 prfont-weight text-center w-100" role="alert">شما تا این لحظه {{ convertToPersian(String(sumBenefit)) }} تومان درآمد کسب کرده اید.</div>
            <table class="mt-2 table table-hover table-bordered table-striped" id="orderTable">
              <thead>
                <tr>
                  <th scope="col">شماره تراکنش</th>
                  <th scope="col">نوع درآمد</th>
                  <th scope="col">تاریخ ساعت</th>
                  <th scope="col">مبلغ کل (تومان)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id" :data-id="item.id">
                  <td>{{ convertToPersian(String(item.id)) }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ convertToPersian(String(item.amount)) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane fade " :class="{ 'active show': flag.two }" id="two" role="tabpanel" aria-labelledby="two-tab">
            <div class="alert alert-warning my-1 border-0 prfont-weight text-center w-100" role="alert" v-if="reagentCount > 0">شما تا این لحظه {{ convertToPersian(String(reagentCount)) }} نفر را به راداَپ دعوت کرده اید و در سود خرید هایشان با ما سهیم بوده اید.</div>
            <div class="alert alert-warning my-1 border-0 prfont-weight text-center w-100" role="alert" v-if="reagentCount == 0">شما تا این لحظه کسی را به راداَپ معرفی نکرده اید .</div>
            <button class="btn btn-success w-100" @click="shareLink" v-if="reagentCount == 0"> اشتراک گذاری لینک دعوت<i class="fa fa-share"></i></button>
            <table class=" table table-hover table-striped" v-if="reagentList" >
              <thead>
                <tr role="row">
                  <th>ردیف</th>
                  <th>نام و نام خانوادگی</th>
                </tr>
              </thead>

              <tbody>
                <tr role="row" class="odd" v-for="item, index in reagentList" :key="item.id">
                  <td>{{ convertToPersian(String(index + 1)) }}</td>
                  <td>{{ item.name }} {{ item.family }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "@vue/reactivity";
import { convertToPersian } from "@/composables/digits";
let userInfo = ref();
let sumBenefit = ref(0);
let items = ref();
let reagentCode = ref();
let reagentList = ref();
let reagentCount = ref();
let flag = reactive({
  one: true,
  two: false
})
getLocalStorage()
getTransaction();
getReagented()
async function getTransaction() {
  let response = await fetch('https://radap.ir/Backend/api/account/transaction/get.php?userId=' + userInfo.value[0]['id'] + '&type=1')
  let data = await response.json()
    items.value = data.data;
    sumBenefit.value = data.sum
}
function flagFlag(num) {
  // function flagFlag(e,num){
  flag.one = false
  flag.two = false
  if (num == 'one') {
    flag.one = true
  } else {
    flag.two = true
  }
}
async function getReagented() {
  let response = await fetch("https://radap.ir/Backend/api/account/reagent/get.php?id=" + userInfo.value[0]['id'])
  let data = await response.json()
    reagentList.value = data.data
    reagentCount.value = data.count
}

function getLocalStorage() {
  userInfo.value = JSON.parse(localStorage.getItem('userInfo'));
}
async function shareLink() {
  getLocalStorage()
  reagentCode.value = 'https://radap.ir/Invite/'+userInfo.value[0].token
  const shareData = {
    title: "لینک معرفی",
    text:'سلام، توی راداَپ ضمن تهیه مایحتاج روزانت با قیمت مناسب و پیک رایگان درآمد هم داشته باش،روی لینک دعوت من بزن و با ثبت نام توی راداَپ 10.000تومان اعتبار هدیه دریافت کن، حس خوب خرید با راداَپ',
    url: reagentCode.value
  };
  try {
    await navigator.share(shareData);
  } catch (err) {
    console.log(err);
  }
}
</script>

<style scoped>
table thead tr th {
  text-align: right;
}
</style>